import React from 'react';
import { IReferencedPayment } from '@components/Sura/Stepper/ReferencedPayment/types';
import { Grid } from '@material-ui/core';
import useStyles from '@components/Sura/Stepper/styles';

import PaymentMethodCard from '@components/Sura/PaymentMethodCard';
import { observer } from 'mobx-react';
import SEND_REFERENCE from '@assets/images/enviar-referencia.svg';
import DOWNLOAD_REFERENCE from '@assets/images/descargar-referencia.svg';
import { PaymentOption } from '@store/sura';
import useStore from '@hooks/useStore';

const ReferencedPayment: React.FC<IReferencedPayment> = () => {
  const { ui, sura } = useStore();
  const css = useStyles({ isMobile: ui.isMobileScreen });
  const isLoading = sura.flag;

  return (
    <>
      <label className={css.labelPayment}>Envio de referencia</label>
      <Grid className={css.divCards} container spacing={ui.isMobileScreen ? 1 : 3}>
        <Grid xs={ui.isMobileScreen ? 12 : 4}>
          <PaymentMethodCard
            imageSrc={SEND_REFERENCE}
            paymentMethod={'Enviar'}
            description={'Envia un recibo para pago de primas, con la referencia asignada'}
            disabled={false}
            paymentMethodSelected={''}
            paymentOption={PaymentOption.send_reference}
          />
        </Grid>
        <Grid xs={ui.isMobileScreen ? 12 : 4}>
          <PaymentMethodCard
            imageSrc={DOWNLOAD_REFERENCE}
            paymentMethod={'Descargar'}
            description={'Descarga tu recibo para pago de primas, con la referencia asignada'}
            disabled={isLoading}
            paymentMethodSelected={''}
            paymentOption={PaymentOption.download_reference}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default observer(ReferencedPayment);
